import { useState } from "react";
import { DISCUSS_LIST } from "@/mocks/home";
import SectionHeader from "./SectionHeader";

const tagDot: Record<string, string> = {
  影视: "bg-primary-500",
  综艺: "bg-accent-500",
  科技: "bg-secondary-500",
  体育: "bg-primary-500",
};

interface Card {
  id: number;
  user: string;
  text: string;
  likes: number;
  comments: number;
  time: string;
  tag: string;
  color: string;
}

export default function Discuss() {
  const [cards, setCards] = useState<Card[]>(DISCUSS_LIST);
  const [liked, setLiked] = useState<number[]>([]);
  const [text, setText] = useState("");
  const [sent, setSent] = useState("");

  const toggleLike = (id: number) => {
    setLiked((cur) => {
      const has = cur.includes(id);
      const next = has ? cur.filter((x) => x !== id) : [...cur, id];
      setCards((list) =>
        list.map((c) => (c.id === id ? { ...c, likes: c.likes + (has ? -1 : 1) } : c))
      );
      return next;
    });
  };

  const submit = () => {
    const v = text.trim();
    if (!v) return;
    const id = Date.now();
    const tag = "热议";
    setCards((list) => [
      { id, user: "热心瓜友", text: v, likes: 0, comments: 0, time: "刚刚", tag, color: "bg-accent-500" },
      ...list,
    ]);
    setText("");
    setSent("已发布你的观点，正在参与讨论 ~");
    setTimeout(() => setSent(""), 4000);
  };

  return (
    <section id="focus" className="bg-background-100 py-14 md:py-20">
      <SectionHeader
        eyebrow="焦点热议 / DISCUSS"
        title="围观网友都在聊什么"
        desc="这里是本月大瓜焦点与爆点的讨论现场。给认同的观点点个赞，或发表你的看法加入前排围观。"
        accent
      />

      <div className="mx-auto mt-8 max-w-4xl px-4 md:px-6">
        <div className="rounded-2xl border border-background-200 bg-background-50 p-5">
          <label htmlFor="opinion" className="text-sm font-semibold text-foreground-950">
            发表你的观点
          </label>
          <div className="mt-3 flex flex-col gap-3 sm:flex-row">
            <input
              id="opinion"
              value={text}
              onChange={(e) => setText(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && submit()}
              placeholder="说点什么，一起蹲这个瓜…"
              className="w-full rounded-xl border border-background-200 bg-background-100 px-4 py-2.5 text-sm text-foreground-950 outline-none placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
            />
            <button
              type="button"
              onClick={submit}
              className="inline-flex shrink-0 items-center justify-center gap-1 whitespace-nowrap rounded-xl bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
            >
              <i className="ri-send-plane-fill" /> 发布
            </button>
          </div>
          {sent && (
            <p className="mt-3 flex items-center gap-1.5 text-xs font-medium text-accent-700">
              <i className="ri-checkbox-circle-fill" /> {sent}
            </p>
          )}
        </div>

        <div className="mt-6 flex flex-col gap-4">
          {cards.map((c) => {
            const isLiked = liked.includes(c.id);
            return (
              <article
                key={c.id}
                className="rounded-2xl border border-background-200 bg-background-50 p-5 transition hover:border-accent-300"
              >
                <div className="flex items-center gap-3">
                  <span
                    className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-bold text-background-50 ${c.color}`}
                  >
                    {c.user.slice(0, 1)}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-bold text-foreground-950">{c.user}</p>
                    <p className="text-xs text-foreground-500">{c.time}</p>
                  </div>
                  <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
                    <span className={`h-1.5 w-1.5 rounded-full ${tagDot[c.tag] || "bg-accent-500"}`} />
                    {c.tag}
                  </span>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700">{c.text}</p>
                <div className="mt-4 flex items-center gap-5 border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <button
                    type="button"
                    onClick={() => toggleLike(c.id)}
                    className={`inline-flex items-center gap-1.5 font-medium transition ${
                      isLiked ? "text-primary-600" : "hover:text-primary-700"
                    }`}
                  >
                    <i className={`${isLiked ? "ri-heart-fill" : "ri-heart-3-line"} text-base`} />
                    {c.likes.toLocaleString()}
                  </button>
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-chat-3-line text-base" /> {c.comments.toLocaleString()}
                  </span>
                  <span className="ml-auto hidden items-center gap-1 sm:inline-flex">
                    <i className="ri-share-forward-line text-base" /> 转发围观
                  </span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}